import React from 'react';
import { useState, useEffect } from 'react';
import { flowRight } from 'lodash/fp';
import { withRouter } from 'react-router-dom';
import { withSnackbar } from 'notistack';

import UserForm from './UserForm';
import { loadUserInfo, updateUser, loadCompany } from './services';

let EditUser = props => {
    const { history, enqueueSnackbar, match } = props;
    const { id, company_id: companyId } = match.params;
    const [currentUser, setCurrentUser] = useState(null);
    const [additionalData, setAdditionalData] = useState({
        companyGroups: [],
        roles: [],
    });

    const [serverSideErrors, setServerSideErrors] = useState({});

    useEffect(() => {
        loadUserInfo(id, companyId).then(({ user, roles, groups, users }) => {
            setCurrentUser(user);
            setAdditionalData({
                roles,
                companyGroups: groups,
                portalUsers: users,
            });
            loadCompany(companyId).then(company =>
                props.updateBreadcrumbs([
                    { name: 'Companies', path: '/companies' },
                    {
                        name: company.business_name,
                        path: `/companies/${companyId}`,
                    },
                    `${user.first_name} ${user.last_name}`,
                ])
            );
        });
    }, []);

    const handleSave = userDetails => {
        updateUser(userDetails, companyId).then(json => {
            if (json.error) {
                setServerSideErrors({ error: json.error });
            } else {
                enqueueSnackbar('Partner portal access will be updated', {
                    variant: 'info',
                });
                history.push(`/companies/${companyId}/partner/access/`);
            }
        });
    };
    if (currentUser) {
        return (
            <UserForm
                editable={true}
                currentUser={currentUser}
                onSave={handleSave}
                additionalData={additionalData}
                serverSideErrors={serverSideErrors}
                companyId={companyId}
            />
        );
    }
    return <div />;
};

export default flowRight(withSnackbar, withRouter)(EditUser);
